import { qsa, contains } from "@fluorescent/dom";
import {
  FadeUpReveal,
  FadeUpSplitReveal,
  intersectionWatcher,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  group: ".section-header, .testimonials__item",
  revealItem: ".animation-fade-up-split-reveal, .animation-fade-up-reveal",
};

export default node => {
  let observer = null;
  // Each group has a staggered animation delay so we get each groups container
  const revealGroup = qsa(selectors.group, node);

  const reveals = [];

  if (shouldAnimate(node)) {
    // Initialize animations and intersection observer
    // Loop through each reveal group and initialize the reveals for each item in the group
    revealGroup.forEach(item => {
      const groupReveals = [];
      qsa(selectors.revealItem, item).forEach(revealItem => {
        // check which type of reveal needs to be initialized
        if (contains(revealItem, "animation-fade-up-split-reveal")) {
          groupReveals.push(new FadeUpSplitReveal(revealItem));
        } else if (contains(revealItem, "animation-fade-up-reveal")) {
          groupReveals.push(new FadeUpReveal(revealItem));
        }
      });
      reveals.push(groupReveals);
    });

    observer = intersectionWatcher(node, { cb: isVisible });
  }

  function isVisible() {
    // increment a delay for each group of reveal animations
    let revealGroupDelay = 0;
    // loop through each group
    reveals.forEach((revealGroup, i) => {
      revealGroupDelay = window.theme.animation.delay * i;

      let previousType = null;
      // loop through each reveal item in the group
      revealGroup.forEach((revealItem, j) => {
        // This section is a little different.
        // This section has a quote icon in each group that needs to
        // animate at the same time as the first line of text in the title.
        // Here we only apply the item delay if the previous item isn't the icon
        if (
          revealItem.type !== "FadeUpSplitReveal" ||
          (revealItem.type !== "FadeUpSplitReveal" &&
            previousType === "FadeUpSplitReveal")
        ) {
          revealGroupDelay += window.theme.animation.delay * j;
        }
        revealItem.play(revealGroupDelay);
        previousType = revealItem.type;
      });
    });
  }

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
